import React from 'react';

import { Box, Text } from '@opendoor/bricks/core';

import { GenericErrorPage } from 'shared/routes/errors/GenericErrorPage';

/** Page to show when user is trying to access their offer with the wrong account. */
export const WrongAccountPage: React.FC = () => {
  return (
    <GenericErrorPage
      reason="wrong-account"
      causedBy="user-error"
      headerContent="This offer may be linked to a different email address"
      errorContent={
        <Box textAlign="left">
          <Text textAlign="center">Try signing in to Opendoor with another email to view it.</Text>
        </Box>
      }
    />
  );
};
